import { define } from 'wicked-elements'
import mostVisible from 'most-visible/js/most-visible'
// import 'scroll-start-stop-events'
import { bus } from '../../bus.js'

define('[data-map-scroll]', {
  init() {
    this.$elements = [...this.element.querySelectorAll('[data-uuid]')]
    this.handleScroll = this.handleScroll.bind(this)
  },
  connected () {
    window.addEventListener('scroll', this.handleScroll)
  },
  disconnected () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  handleScroll () {
    const visibleLocation = mostVisible(this.$elements)
    if (visibleLocation) {
      const uuid = visibleLocation?.dataset?.uuid?.trim()
      if (uuid) {
        bus.emit('map:setactive', [uuid])
      }
    } else {
      bus.emit('map:clearactive')
    }
  }
})